"use client";

import { Badge } from "@oreme/ui";
import React, { type HTMLAttributes, type ReactElement } from "react";
import type { Label } from "@/types";

interface LabelListItemProps extends HTMLAttributes<HTMLDivElement> {
  label: Label;
}

function LabelListItem({ label }: Readonly<LabelListItemProps>): ReactElement {
  return (
    <div className="overflow-hidden">
      <Badge
        className="border-0 min-w-0 max-w-full bg-yellow-500 hover:bg-yellow-500 text-xs truncate"
        title={label.name}
      >
        <span className="text-black text-xs truncate">{label.name}</span>
      </Badge>
    </div>
  );
}

export { LabelListItem, type LabelListItemProps };
